// extracted by mini-css-extract-plugin
module.exports = {"Form":"UpsellDowngradeForm_Form__1UO50","divider":"UpsellDowngradeForm_divider__2ZGEp","subtitle":"UpsellDowngradeForm_subtitle__3Tbsv"};